import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import ConfigsModule from '../../configs/configs';
import template from './campaignsForm.jade';
import {
  maxDailyBudgetValue,
  numberBetween,
  isInteger,
  twoDecimalDigitsValidator,
  isShorterThenMaxLength,
  normalizeAutoGoalsOptimizationFields
} from '../../common/util/validation-util';

export class CampaignsFormController {
  /* @ngInject */
  constructor($filter, $state, $stateParams, TargetingResource, platformsOptions, currentGame, currentUser, CampaignsV4Resource, notify, $timeout, $q, stopReasonsOptions){
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.$stateParams = $stateParams;
    currentGame.subscribe(game => this.game = game);
    currentUser.subscribe(user => this.user = user);
    this.TargetingResource = TargetingResource;
    this.CampaignsV4Resource = CampaignsV4Resource;
    this.$q = $q;
    this.notify = notify;
    this.timezoneName = moment.tz(moment.tz.guess()).format('z Z');
    this.show = this.translate('show');
    this.hide = this.translate('hide');
    const descriptionPossibleValues = this.game.simplaex_field_configs.description.possible_values;
    const descriptionOptions = descriptionPossibleValues ? descriptionPossibleValues.map(option => { return { value: option, name: option } }) : [];
    let vm = this;

    this.stopReasons = stopReasonsOptions;

    if (this.campaign.id) {
      if (this.campaign.inherit_data_from_campaign_id !== undefined) {
        switch (this.campaign.inherit_data_from_campaign_id) {
          case -2:
            // None campaign case - use None as game
            this.campaign.inherit_data_from_game_id = -1
            break;
          case -1:
            // Average Campaign case - use None as game
            this.campaign.inherit_data_from_game_id = -1
            break;
          default:
            this.CampaignsV4Resource.one(this.campaign.inherit_data_from_campaign_id).get().then((inherit_data_from_campaign) => {
              this.campaign.inherit_data_from_game_id = inherit_data_from_campaign.game_id;
            })
            break;
        }
      } else {
        this.campaign.inherit_data_from_game_id = -1;
      }
    }

    this.currencyField = {
      className: 'layout__item u-2/12 formly-text',
      key: 'currency',
      template: `<div class="c-field"><input type="{{to.type||'text'}}" class="c-input" value="{{model[options.key] | translate }}" disabled></div>`,
      templateOptions: {
        disabled: true,
        label: ''
      }
    };

    this.attributionTimeUnitDaysField = {
      className: 'layout__item u-1/12 formly-text',
      key: 'a',
      template: `<div class="c-field"><input type="{{to.type||'text'}}" class="c-input" value="{{ 'Days' }}" disabled></div>`,
      templateOptions: {
        disabled: true,
        label: ''
      }
    };

    this.sspTypeOptions = [];
    this.initSsps();

    this.budgetCappingTypeForCPCField = {
      className: 'layout__item u-2/7',
      type: 'uiSelect',
      key: 'budget_capping_type',
      defaultValue: 'Monetary',
      templateOptions: {
        required: true,
        options: [
          {
            name: 'USD ($)',
            value: 'Monetary'
          },
          {
            name: 'Clicks',
            value: 'Event'
          },
          {
            name: 'Unlimited',
            value: 'Unlimited'
          }
        ]
      }
    };

    this.monthlyBudgetCappingType = {
      className: 'layout__item u-3/12',
      type: 'uiSelect',
      key: 'monthly_budget_capping_type',
      defaultValue: 'Unlimited',
      templateOptions: {
        label: '',
        required: true,
        options: [
          {
            name: 'USD ($)',
            value: 'Monetary'
          },
          {
            name: 'Clicks',
            value: 'Event'
          },
          {
            name: 'Unlimited',
            value: 'Unlimited'
          }
        ]
      }
    };

    this.budgetCappingTypeForCPAField = {
      className: 'layout__item u-2/7',
      type: 'uiSelect',
      key: 'budget_capping_type',
      defaultValue: 'Monetary',
      templateOptions: {
        required: true,
        options: [
          {
            name: 'USD ($)',
            value: 'Monetary'
          },
          {
            name: 'Conversions',
            value: 'Event'
          },
          {
            name: 'Unlimited',
            value: 'Unlimited'
          }
        ]
      }
    };

    this.budgetCappingTypeForCPIField = {
      className: 'layout__item u-2/7',
      type: 'uiSelect',
      key: 'budget_capping_type',
      defaultValue: 'Monetary',
      templateOptions: {
        required: true,
        options: [
          {
            name: 'USD ($)',
            value: 'Monetary'
          },
          {
            name: 'Installs',
            value: 'Event'
          },
          {
            name: 'Unlimited',
            value: 'Unlimited'
          }
        ]
      }
    };

    this.lookalikeBundlesField = {
      label: this.translate('lookalike_bundles') + ' ',
      rowFields: [
        {
          className: 'layout__item u-4/6',
          type: 'textarea',
          key: 'lookalike_bundles',
          templateOptions: {
            label: '',
            required: false,
            placeholder: '',
          },
          validators: {
            maxlength: {
              expression: ($viewValue, $modelValue, scope) => {
                return _.every($viewValue.split('\n'), v => isShorterThenMaxLength(v, 100));
              }
            }
          }
        }
      ]
    };

    this.rows = [
      {
        label: this.translate('campaign_status') + ' ',
        stopReasonAnchor: 'pause',
        rowFields: [
          {
            className: 'layout__item u-4/12 c-switch--single',
            type: 'radioSwitch',
            key: 'status',
            defaultValue: 'paused',
            hideExpression: "model.status == 'paused_due_to_budget'",
            templateOptions: {
              label: '',
              required: true,
              onChange: (($viewValue,$modelValue,$scope) => {
                $timeout(() => {
                  let newValue = $scope.model[$scope.name];
                  if (newValue == 'paused') {
                    this.disabledOptions.start_mode_immediate = false;
                    this.disabledOptions.start_mode_dont_start = false;
                    delete $scope.model.start_date;
                    delete $scope.model.end_date;
                    $scope.model.start_mode = 'dont_start';
                    $scope.model.end_mode = 'never';
                    this.notify.warning('campaignPausing');
                  } else { // activate
                    this.disabledOptions.start_mode_immediate = false;
                    this.disabledOptions.start_mode_dont_start = false;
                    $scope.model.start_mode = 'immediate';
                    $scope.model.end_mode = 'never';
                    delete $scope.model.stop_reason;
                    this.notify.warning('campaignActivate');
                    this.notify.warning('willActivateSegments');
                  }
                })
              }),
              options: [
                {
                  name: this.translate('active'),
                  value: 'active'
                },
                {
                  name: this.translate('paused'),
                  value: 'paused'
                }
              ]
            }
          },
          {
            className: 'layout__item u-3/12 formly-text',
            key: 'paused_due_to_budget_status',
            hideExpression: "model.status !== 'paused_due_to_budget'",
            template: `<label class="c-text c-text--small c-text--faded"> {{ 'paused_due_to_budget' | translate }} </label>`,
            templateOptions: {
              label: ''
            }
          },
          {
            className: 'layout__item u-1/12 formly-text',
            key: 'dont_continue_btn',
            template: `<a class="o-btn c-btn c-btn--outlined c-btn--small c-btn--warning" id='dont_continue_campaign_btn' ng-click="to.onClick($event,this)">
                {{ 'discontinue_campaign' | translate }}
                </a>`,
            hideExpression: "model.status !== 'paused_due_to_budget'",
            templateOptions: {
              label: '',
              onClick: (($viewValue,$scope) => {
                $scope.model.end_mode = 'specific_date';
                $scope.model.end_date = moment().startOf('day').add(1,'days').toDate();
              })
            }
          }
        ]
      },
      {
        label: this.translate('campaign_name') + ' ',
        rowFields: [
          {
            className: 'layout__item u-1/1',
            type: 'input',
            key: 'name',
            templateOptions: {
              label: '',
              required: true,
              placeholder: this.translateWith('enter_here', 'name')
            }
          }
        ]
      },
      {
        label: this.translate('advertising_type') + ' ',
        rowFields: [
          {
            className: 'layout__item u-1/4',
            type: 'uiSelect',
            key: 'campaign_advertising_type',
            templateOptions: {
              label: '',
              required: true,
              onChange: (($viewValue,$modelValue,$scope) => {
                if ($viewValue !== 'UserAcquisition') {
                  $scope.model.lookalike_bundles = '';
                  this.removeLookalikeField();
                } else {
                  this.showLookalikeField();
                }
              }),
              options: [
                {
                  name: this.translate('reengagement'),
                  value: 'Reengagement'
                },
                {
                  name: this.translate('user_acquisition'),
                  value: 'UserAcquisition'
                }
              ]
            },
          },
          {
            className: 'layout__item u-1/2',
            hideExpression: 'model.campaign_advertising_type !== "UserAcquisition"',
            expressionProperties: {
              "templateOptions.label": "'cross_promotion' | translate"
            },
            type: 'checkbox',
            key: 'cross_promotion',
          }
        ]
      },
      {
        label: this.translate('choose_segment') + ' ',
        hide: this.isUACampaign() || this.isUACPMCampaign() || this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-1/1',
            key: '_segment_ids',
            type: 'uiSelectMultiple',
            templateOptions: {
              label: '',
              required: true,
              options: []
            },
            controller: /* @ngInject */ ($scope) => {
              this.getSegments().then((segments) => {
                $scope.options.templateOptions.options = segments.map((value) => {
                  return {value: value.id, name: value.name};
                })

                $scope.model._segment_ids = (this.campaign.segments || []).map(s => s.id);
                $scope.$watch('model._segment_ids', (selectedIds) => {
                  selectedIds = selectedIds || [];
                  const existingDeviceTypes = new Map(
                      (this.campaign.segments || []).map(s => [s.id, s.device_id_type])
                  );

                  this.campaign.segments = selectedIds.map(id => ({
                    id,
                    device_id_type: existingDeviceTypes.get(id) || 'All'
                  }));
                });
              });
            }
          },
          {
            className: 'layout__item u-1/2 formly-text',
            hide: this.campaign.id,
            key: 'new_segment',
            template: `<label class="c-text c-text--small c-text--faded"> {{ 'or' | translate }} </label>
                  <a class="c-link c-text--small c-link--primary" id='create_new_segment_btn' ng-click="to.onClick($event)">
                     {{ 'createNew' | translateWith:'segment' }}
                  </a>`,
            templateOptions: {
              label: '',
              onClick: (event => {
                  return $state.go('app.segments.index', {gameId: $stateParams.gameId, new: true, type: 'engagement'})
                }
              )
            }
          }
        ]
      },
      {
        label: this.translate('audience') + ' ',
        hide: !this.isUACampaign() && !this.isUACPMCampaign() && !this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'audience_id',
            templateOptions: {
              required: true,
              label: ''
            },
            expressionProperties: {
              "templateOptions.disabled": () => {return this.campaign.id}
            },
            controller: /* @ngInject */ ($scope) => {
              this.getAudiences().then((audiences) => {
                $scope.options.templateOptions.options = audiences.map((value) => {
                  return {value: value.id, name: value.name};
                });
              });
            }
          }
        ]
      },
      {
        label: this.translate('daily_budget') + ' ',
        help: 'Daily Budget (up to $20,000)',
        rowFields: [
          {
            className: 'layout__item u-1/7',
            type: 'input',
            key: 'budget_amount',
            templateOptions: {
              placeholder: this.translateWith('set','budget'),
              required: true,
            },
            validators: {
              maxDailyBudgetValue: {
                expression: ($viewValue, $modelValue, scope) => {
                  return maxDailyBudgetValue(parseFloat($viewValue));
                }
              }
            }
          },
          this.showBudgetCappingTypeField(),
          {
            className: 'layout__item u-4/7',
            type: 'radio',
            key: 'autopilot_launcher_state',
            defaultValue: 'inactive',
            templateOptions: {
              label: this.translate('autopilot_launcher'),
              required: true,
              options: [
                {
                  name: this.translate('active'),
                  value: 'active',
                },
                {
                  name: this.translate('on_hold'),
                  value: 'on_hold'
                },
                {
                  name: this.translate('inactive'),
                  value: 'inactive',
                }
              ],
              tooltipText: this.translate('autopilot_launcher')
            },
          },
          {
            className: 'layout__item u-2/7',
            type: 'input',
            key: 'autopilot_launcher_message',
            hideExpression: function($viewValue, $modelValue, scope) {
              return scope.$parent.vm.campaign.autopilot_launcher_state !== 'on_hold';
            },
            templateOptions: {
              label: 'On Hold Message:',
              required: true,
            }
          },
          {
            className: 'layout__item u-1/7',
            type: 'input',
            hideExpression: 'model.campaign_advertising_type !== "UserAcquisition"',
            key: 'daily_exploration_budget_amount',
            templateOptions: {
              placeholder: 'Set Exploration Budget',
              label: 'Exploration Budget'
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => {
                  return _.isEmpty($viewValue) || numberBetween(parseFloat($viewValue), 0, scope.model.budget_amount === undefined ? Number.POSITIVE_INFINITY : parseFloat(scope.model.budget_amount));
                }
              }
            }
          },
          {
            className: 'layout__item u-2/12',
            type: 'uiSelect',
            hideExpression: 'model.campaign_advertising_type !== "UserAcquisition"',
            key: 'daily_exploration_budget_type',
            defaultValue: 'Monetary',
            templateOptions: {
              label: 'Exploration Budget Type',
              options: [
                {
                  name: 'USD ($)',
                  value: 'Monetary'
                }
              ]
            }
          }
        ]
      },
      {
        label: this.translate('monthly_budget_amount') + ' ',
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'monthly_budget_amount',
            expressionProperties: {
              "templateOptions.disabled": function($viewValue, $modelValue, scope) {
                return scope.model.monthly_budget_capping_type === "Unlimited";
              }
            },
            templateOptions: {
              placeholder: this.translateWith('set','monthly_budget_amount'),
              required: false,
              label: ''
            },
            validators: {
              nonUnlimitedValueNotEmpty: function($viewValue, $modelValue, scope) {
                return scope.model.monthly_budget_capping_type === 'Unlimited' || !_.isEmpty($viewValue);
              }},
            extras: {validateOnModelChange: true},
          },
          this.monthlyBudgetCappingType
        ]
      },
      {
        label: this.translate('expenses_threshold'),
        hide: !(this.isUACampaign() && this.user.hasRole(['ADMIN','GG_ACCOUNT_MANAGER'])),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'expenses_threshold',
            templateOptions: {
              label: '',
              required: false
            }
          }
        ]
      },
      {
        label: this.translate('second_auction_bid'),
        hide: !this.isUACampaign() && !this.isUACPMCampaign() && !this.isBrandingCPMCampaign(),
        help: this.translate('second_auction_bid_help'),
        helpTextPlacement: 'right',
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'second_auction_bid',
            templateOptions: {
              placeholder: this.translateWith('set','second_auction_bid'),
              required: false,
              label: ''
            }
          }
        ]
      },
      {
        label: this.translate('conversion') + ' ' + this.translate('event') + ' ',
        help: 'For all incoming events of this type it will be checked if a conversion can be attributed.',
        hide: this.isUACampaign() || this.isUACPMCampaign() || this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/6',
            type: 'uiSelect',
            key: 'campaign_success_metric',
            defaultValue: 'game_event_sessions_start',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: 'Clicked on an ad',
                  value: 'clicked_on_ad'
                },
                {
                  name: 'Game Event: Sessions start',
                  value: 'game_event_sessions_start'
                },
                {
                  name: 'Game Event: Payment',
                  value: 'game_event_payment'
                },
                {
                  name: 'Game Event: Progress',
                  value: 'game_event_progress'
                },
                {
                  name: 'Game Event: New Player',
                  value: 'game_event_new_player'
                },
                {
                  name: 'Game Event: Ad Revenue',
                  value: 'game_event_ad_revenue'
                }
              ]
            },
            expressionProperties: {
              "templateOptions.disabled": () => {return this.campaign.id}
            },
          },
          {
            className: 'layout__item u-6/12',
            type: 'uiSelectMultipleFiltered',
            key: 'success_metric_external_event',
            defaultValue: null,
            hideExpression: 'model.campaign_success_metric !== "game_event_progress"',
            templateOptions: {
              label: '',
              required: false,
              options: this.campaign.success_metric_external_event ? this.campaign.success_metric_external_event.map(option => { return { value: option, name: option } })  : descriptionOptions

            },
            expressionProperties: {
              "templateOptions.disabled": () => {return this.campaign.id}
            },
          }
        ]
      },
      {
        label: this.translate('conversion') + ' ' + this.translate('attribution') + ' ',
        help: 'Configures if a user can only be converted once (“unique”) or if every attributed conversion event for the same user will be counted as a conversion (“non unique”)',
        hide: this.isUACampaign() || this.isUACPMCampaign() || this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/6',
            type: 'uiSelect',
            key: 'conversion_attribution',
            defaultValue: 'unique',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: 'Unique',
                  value: 'unique'
                },
                {
                  name: 'Non Unique',
                  value: 'non_unique'
                },
              ]
            },
            expressionProperties: {
              "templateOptions.disabled": () => {return this.campaign.id}
            },
          }
        ]
      },
      this.showCostPerEngagementField(),
      {
        label: this.translate('engagement') + ' ' + this.translate('event') + ' ',
        hide: !this.isUACampaign() && !this.isUACPMCampaign() && !this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/6',
            type: 'uiSelect',
            key: 'campaign_success_metric',
            defaultValue: 'game_event_sessions_start',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: 'Game Event: Sessions start',
                  value: 'game_event_sessions_start'
                },
                {
                  name: 'Game Event: New User',
                  value: 'game_event_new_player'
                }
              ]
            },
            expressionProperties: {
              "templateOptions.disabled": () => {return this.campaign.id || this.isBrandingCPMCampaign()}
            }
          }
        ]
      },
      {
        label: this.translate('campaign') + this.translate('strategy') + ' ',
        hide: !this.isUACPMCampaign() && !this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/6',
            type: 'uiSelect',
            key: 'strategy',
            defaultValue: 'accelerated',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: this.translate('accelerated'),
                  value: 'accelerated'
                },
                {
                  name: this.translate('moderate'),
                  value: 'moderate'
                },
                {
                  name: this.translate('limited'),
                  value: 'limited'
                }
              ]
            }
          },
          {
            className: 'layout__item u-3/12 formly-text',
            template: `<gg-info-icon text="{{ 'campaign_strategy_help.' + model.strategy | translate }}">`
          }
        ]
      },
      {
        label: this.translate('max_bid_price') + ' ',
        hide: !this.isUACPMCampaign() && !this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-1/4',
            type: 'input',
            key: 'forced_price',
            templateOptions: {
              label: '',
              type: 'number',
              placeholder: this.translateWith('enter_here', 'max_bid_price')
            }
          }
        ]
      },
      {
        label: this.translate('campaign_start') + ' ',
        help: this.translate('campaign_start') + ` (${this.timezoneName})`,
        rowFields: [
          {
            className: 'layout__item u-4/12',
            type: 'radio',
            key: 'start_mode',
            defaultValue: 'dont_start',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: this.translate('immediate'),
                  value: 'immediate',
                  isDisabled: () => {
                    return this.disabledOptions.start_mode_immediate === true;
                  }
                },
                {
                  name: this.translate('specific_date'),
                  value: 'specific_date'
                },
                {
                  name: this.translate('dont_start'),
                  value: 'dont_start',
                  isDisabled: () => {
                    return this.disabledOptions.start_mode_dont_start === true;
                  }
                }
              ],
              onChange: (($viewValue,$modelValue,$scope) => {
                $timeout(() => {
                  let newValue = $scope.model[$scope.name];
                  if (newValue == 'immediate' && $scope.model.status == 'paused') {
                    $scope.model.status = 'active';
                    this.notify.warning('campaignActivate');
                  }
                })
              })
            },
            expressionProperties: {
              "templateOptions.disabled": function($viewValue, $modelValue, scope) {
                return scope.model.status === 'active';
              }
            }
          },
          {
            className: 'layout__item u-4/12',
            type: 'dateInput',
            key: 'start_date',
            hideExpression: 'model.start_mode == "immediate" || model.start_mode == "dont_start"',
            extras: {validateOnModelChange: true},
            validators: {
              setStartDateForPausedCampaignNotInPast: function($viewValue, $modelValue, scope) {
                vm.handleStartDateChange($viewValue, $modelValue, scope);
                return !(scope.model.status==='paused' && moment(scope.model.start_date).isBefore(moment(),'days'));
              }
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'timeInput',
            key: 'start_date',
            hideExpression: 'model.start_mode == "immediate" || model.start_mode == "dont_start"',
            templateOptions: {
              label: '',
              required: true
            }
          }
        ]
      },
      {
        label: this.translate('campaign_end') + ' ',
        help: this.translate('campaign_end') + ` (${this.timezoneName})`,
        stopReasonAnchor: 'endDate',
        rowFields: [
          {
            className: 'layout__item u-4/12',
            type: 'radio',
            key: 'end_mode',
            defaultValue: 'never',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: this.translate('never'),
                  value: 'never'
                },
                {
                  name: this.translate('specific_date'),
                  value: 'specific_date'
                }
              ]
            }
          },
          {
            className: 'layout__item u-4/12',
            type: 'dateInput',
            key: 'end_date',
            hideExpression: 'model.end_mode == "never"',
            extras: {validateOnModelChange: true},
            templateOptions: {
              label: '',
              required: true
            },
            validators: {
              endDateNotInPast: function($viewValue, $modelValue, scope) {
                return !moment(scope.model.end_date).isBefore(moment(),'days');
              }}
          },
          {
            className: 'layout__item u-3/12',
            type: 'timeInput',
            key: 'end_date',
            hideExpression: 'model.end_mode == "never"',
            extras: {validateOnModelChange: true},
            templateOptions: {
              label: '',
              required: true
            }
          }
        ]
      }
    ];

    this.advancedTargetingRows = [
      {
        label: this.translate('margin') + ' ',
        hide: !this.isEngagementCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'system_fee',
            templateOptions: {
              label: '',
              type: 'number',
              placeholder: this.translateWith('enter_here', 'margin')
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return numberBetween($viewValue, 0, 99) }
              },
            }
          }
        ]
      },
      {
        label: this.translate('impression_attribution_percentage') + ' ',
        hideBorderBottom: true,
        help: this.translate('impression_attribution_percentage_help'),
        hide: !this.showImpressionAttributionPercentage(),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'impression_attribution_percentage',
            templateOptions: {
              required: false,
              type: 'number'
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return numberBetween($viewValue, 0, 100) }
              },
              isInteger: {
                expression: ($viewValue, $modelValue, scope) => { return isInteger($modelValue) }
              }
            }
          }
        ]
      },
      {
        label: this.translate('spc_cpi') + ' ',
        hide: this.hideSPCCPI(),
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'spc_cpi',
            templateOptions: {
              placeholder: this.translateWith('set','spc_cpi'),
              required: false,
              label: ''
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return !$viewValue || numberBetween($viewValue, 0, 1000) }
              },
              twoDecimalDigits: {
                expression: ($viewValue, $modelValue, scope) => { return !$viewValue || twoDecimalDigitsValidator($modelValue) }
              }
            }
          }
        ]
      },
      {
        label: this.translate('allow_retarget_after_days') + ' ',
        help: this.translate('allow_retarget_after_days_help'),
        rowFields: [{
          className: 'layout__item u-3/12',
          type: 'input',
          key: 'allow_retarget_after_days',
          defaultValue: 5,
          templateOptions: {
            placeholder: this.translateWith('set','allow_retarget_after_days'),
            label: '',
            type: 'number',
            required: true
          }
        }]
      },
      {
        label: this.translate('media_cost') + ' ',
        help: this.translate('media_cost_help'),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'media_cost',
            templateOptions: {
              placeholder: this.translateWith('set', 'media_cost'),
              required: this.isEngagementCPACampaign() || this.isEngagementCPICampaign() || this.isEngagementCPCCampaign(),
              label: ''
            },
            extras: {validateOnModelChange: true},
            validators: {
              twoDecimalDigits: {
                expression: function($viewValue, $modelValue, scope) {
                  let value = $modelValue || $viewValue;
                  let reg = /^[0-9]+(\.[0-9]{1,2})?$/;
                  return !value || value.trim() === '' || reg.test(value);
                }
              }
            }
          },
          this.currencyField
        ]
      },
      {
        label: this.translate('lookback_window') + ' ',
        hideBorderBottom: true
      },
      {
        label: this.translate('click_lookback_window') + ' ',
        help: this.translate('click_lookback_window_help'),
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-1/12',
            type: 'input',
            key: 'click_lookback_window',
            templateOptions: {
              placeholder: '',
              type: 'number',
              required: false
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || numberBetween($viewValue, 0, 31)}
              },
              isInteger: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || isInteger($modelValue) }
              }
            }
          },
          this.attributionTimeUnitDaysField
        ]
      },
      {
        label: this.translate('impression_lookback_window') + ' ',
        help: this.translate('impression_lookback_window_help'),
        rowFields: [{
          className: 'layout__item u-1/12',
          type: 'input',
          key: 'impression_lookback_window',
          templateOptions: {
            placeholder: '',
            type: 'number',
            required: false
          },
          validators: {
            numberBetween: {
              expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || numberBetween($viewValue, 0, 31)}
            },
            isInteger: {
              expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || isInteger($modelValue) }
            }
          }
        },
        this.attributionTimeUnitDaysField
        ]
      },
      {
        label: this.translate('lookback_app_open_window') + ' ',
        hideBorderBottom: true
      },
      {
        label: this.translate('click_lookback_window_app_open') + ' ',
        help: this.translate('click_lookback_window_app_open_help'),
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-1/12',
            type: 'input',
            key: 'click_lookback_window_app_open',
            templateOptions: {
              placeholder: '',
              type: 'number',
              required: false,
              onChange: ($viewValue, $modelValue, $scope) => {
                if ($scope && $scope.form) {
                  $scope.form.$setSubmitted(); // Force revalidation
                }
              },
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || numberBetween($viewValue, 0, 9999)}
              },
              isInteger: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || isInteger($modelValue) }
              }
            }
          },
          {
            className: 'layout__item u-1/12',
            type: 'uiSelectFiltered',
            key: 'click_lookback_window_app_open_time_unit',
            templateOptions: {
              label: '',
              options: [
                {id: 0, name: 'Minutes'},
                {id: 1, name: 'Hours'},
                {id: 2, name: 'Days'}
              ],
              valueProp: 'id',
              labelProp: 'name'
            },
          },
          {
            className: 'layout__item u-1/12',
            type: 'uiDeleteButton',
            key: 'click_lookback_window_app_open_time_unit',
            hideExpression: '!model.click_lookback_window_app_open_time_unit && model.click_lookback_window_app_open_time_unit !== 0',
            templateOptions: {
              onClick: ($viewValue, $modelValue, $scope) => {
                $scope.model.click_lookback_window_app_open_time_unit = null;
                $scope.model.click_lookback_window_app_open = null;
                if ($scope.form) {
                  $scope.form.$setDirty();
                  $scope.form.$setSubmitted();
                }
              },
            }
          }
        ]
      },
      {
        label: this.translate('impression_lookback_window_app_open') + ' ',
        help: this.translate('impression_lookback_window_app_open_help'),
        rowFields: [
          {
            className: 'layout__item u-1/12',
            type: 'input',
            key: 'impression_lookback_window_app_open',
            templateOptions: {
              placeholder: '',
              type: 'number',
              required: false,
              onChange: ($viewValue, $modelValue, $scope) => {
                if ($scope && $scope.form) {
                  $scope.form.$setSubmitted(); // Force revalidation
                }
              },
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || numberBetween($viewValue, 0, 9999)}
              },
              isInteger: {
                expression: ($viewValue, $modelValue, scope) => { return $modelValue == null || isInteger($modelValue) }
              }
            }
          },
          {
            className: 'layout__item u-1/12',
            type: 'uiSelectFiltered',
            key: 'impression_lookback_window_app_open_time_unit',
            templateOptions: {
              label: '',
              options: [
                {id: 0, name: 'Minutes'},
                {id: 1, name: 'Hours'},
                {id: 2, name: 'Days'}
              ],
              valueProp: 'id',
              labelProp: 'name'
            },
          },
          {
            className: 'layout__item u-1/12',
            type: 'uiDeleteButton',
            key: 'impression_lookback_window_app_open_time_unit',
            hideExpression: '!model.impression_lookback_window_app_open_time_unit && model.impression_lookback_window_app_open_time_unit !== 0',
            templateOptions: {
              onClick: ($viewValue, $modelValue, $scope) => {
                $scope.model.impression_lookback_window_app_open_time_unit = null;
                $scope.model.impression_lookback_window_app_open = null;
                if ($scope.form) {
                  $scope.form.$setDirty();
                  $scope.form.$setSubmitted();
                }
              },
            }
          }
        ]
      },
      {
        label: this.translate('upload_tree_data') + ' ',
        help: this.translate('upload_tree_data_help'),
        rowFields: [
          {
            className: 'layout__item u-4/12',
            type: 'uiSelectFiltered',
            key: 'inherit_data_from_game_id',
            expressionProperties: {
              "templateOptions.label": "'upload_tree_data_of_game_id' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {id: '', name: ''}
              ],
              valueProp: 'id',
              labelProp: 'label'
            },
            controller: /* @ngInject */ function ($scope, GamesLimitedResource) {
              $scope.to.loading = GamesLimitedResource.getList()
              .then(function (response) {
                const filteredGames =
                    _.chain(response)
                    .filter(g => g.id > 1466) // filter old Simpalex Apps (https://youappi.atlassian.net/browse/PEP-5233)
                    .map(g => ({...g, label: `${g.name} (${g.id})`}))
                    .value();

                let gamesWithDefaultValue;
                if ($scope.model.inherit_data_from_game_id) {
                  var selectedGame = _.find(filteredGames, g => g.id === $scope.model.inherit_data_from_game_id)
                  var filteredGamesWithoutSelectedGame = _.filter(filteredGames, g => g.id !== $scope.model.inherit_data_from_game_id)
                  gamesWithDefaultValue = [{id: -1, label: 'None'}, selectedGame, ...filteredGamesWithoutSelectedGame];
                } else {
                  gamesWithDefaultValue = [{id: -1, label: 'None'}, ...filteredGames]
                }
                $scope.to.options = gamesWithDefaultValue;
                return gamesWithDefaultValue;
              });
            }
          },
          {
            className: 'layout__item u-4/12',
            type: 'uiSelectFiltered',
            key: 'inherit_data_from_campaign_id',
            expressionProperties: {
              "templateOptions.label": "'upload_tree_data_of_campaign_id' | translate"
            },
            templateOptions: {
              label: '',
              options: [
                {id: '', name: ''}
              ],
              valueProp: 'id',
              labelProp: 'label'
            },

            controller: /* @ngInject */ function ($scope, CampaignsV4Resource) {
              let fetchCampaigns = function($scope, CampaignsV4Resource){
                if ($scope.model.inherit_data_from_game_id !== undefined) {
                  $scope.to.loading = CampaignsV4Resource.getList({game_id: $scope.model.inherit_data_from_game_id})
                  .then(function (response) {
                    const filteredCampaigns =
                        _.chain(response)
                        .filter(c => c.id !== $scope.model.id && c.id !== -1)
                        .map(c => ({...c, label: `${c.name} (${c.id})`}))
                        .value();
                    const defaultCampaignOptions = $scope.model.inherit_data_from_game_id === -1 ? [{id: -2, label: 'None'}, {id: -1, label: 'Average Campaign'}] : [{id: -1, label: 'Average Campaign'}]
                    if ($scope.model.inherit_data_from_campaign_id) {
                      var selectedCampaign = _.find(filteredCampaigns, c => c.id === $scope.model.inherit_data_from_campaign_id)
                      var filteredCampaignsWithoutSelectedCampaign = _.filter(filteredCampaigns, c => c.id !== $scope.model.inherit_data_from_campaign_id)
                      $scope.to.options = [...defaultCampaignOptions, selectedCampaign, ...filteredCampaignsWithoutSelectedCampaign];
                    } else {
                      $scope.to.options = [...defaultCampaignOptions, ...filteredCampaigns];
                    }
                  });
                }
              }

              fetchCampaigns($scope, CampaignsV4Resource);

              $scope.$watch('model.inherit_data_from_game_id', function (newValue, oldValue, theScope) {
                if(newValue !== oldValue) {
                  // don't reset for first initilization
                  if (oldValue && $scope.model.inherit_data_from_campaign_id) {
                    $scope.model.inherit_data_from_campaign_id = undefined;
                  }
                  fetchCampaigns($scope, CampaignsV4Resource);
                }
              });
            }
          }
        ]
      },
      {
        label: this.translate('tree_data_type') + ' ',
        help: this.translate('tree_data_type_help'),
        hide: this.isUACampaign() || this.isUACPMCampaign() || this.isBrandingCPMCampaign(),
        rowFields: [
          {
            className: 'layout__item u-3/12',
            type: 'uiSelect',
            key: 'ml_processing_type',
            defaultValue: 'IdOnly',
            templateOptions: {
              label: '',
              required: true,
              options: [
                {
                  name: 'ID Only',
                  value: 'IdOnly'
                },
                {
                  name: 'All',
                  value: 'All'
                },
              ]
            }
          }
        ]
      },
      {
        label: this.translate('auto_goals_optimization') + ' ',
        rowFields: [
          {
            className: 'layout__item u-4/12 c-switch--single',
            type: 'radioSwitch',
            key: 'auto_goals_optimization',
            defaultValue: false,
            templateOptions: {
              label: '',
              options: [
                {
                  name: 'On',
                  value: true
                },
                {
                  name: 'Off',
                  value: false
                }
              ]
            }
          },
          {
            className: 'layout__item u-6/12 formly-text',
            key: 'auto_goals_optimization_interval_days',
            defaultValue: 3,
            template: `<span class="c-text c-text--normal c-text--faded" style="margin-right: 5px;">{{ 'run_every' | translate }}</span><input type="number" class="c-input" min="1" max="7" style="width: 40px; display: inline-block; vertical-align: middle; margin-right: 5px; padding: 0 4px; text-align: center;" ng-model="model[options.key]" ng-required="model.auto_goals_optimization" /><span class="c-text c-text--normal c-text--faded">{{ 'days_word' | translate }}</span>`,
            templateOptions: {
              label: '',
              required: false
            },
            expressionProperties: {
              'templateOptions.required': 'model.auto_goals_optimization'
            },
            validators: {
              numberBetween: {
                expression: ($viewValue, $modelValue, scope) => {
                  const value = parseInt($modelValue || $viewValue, 10);
                  return !_.isNaN(value) && numberBetween(value, 1, 7);
                }
              },
              isInteger: {
                expression: ($viewValue, $modelValue, scope) => {
                  const value = parseInt($modelValue || $viewValue, 10);
                  return !_.isNaN(value) && isInteger(value);
                }
              }
            }
          },
          {
            className: 'layout__item u-4/12',
            template: '<span></span>'
          },
          {
            className: 'layout__item u-6/12 formly-text',
            key: 'goals_optimization_method',
            defaultValue: 'roi',
            template: `<span class="c-text c-text--normal c-text--faded" style="margin-right: 5px;">{{ 'optimization_method' | translate }}</span><div class="c-select" style="display: inline-block; vertical-align: middle;"><select class="c-select__select" ng-model="model[options.key]"><option value="roi">ROI</option><option value="app_open">App Open</option><option value="conversion">Conversion</option><option value="retention">Retention</option></select></div>`,
            templateOptions: { label: '' }
          }
        ]
      },
    ];

    this.trackingLinksRows = [
      {
        label: this.translate('platforms'),
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-1/1',
            key: 'platforms',
            type: 'checkbuttonMultiple',
            expressionProperties: {
              //"templateOptions.label": "'platforms' | translate"
            },
            templateOptions: {
              label: '',
              options: [{value: 'Global', name: 'Global', icon: 'platform-global'}].concat(platformsOptions),
              required: true
            }
          }
        ]
      },
      {
        label: this.translate('global') + ' ' + this.translate('click') + ' ' + this.translate('URL'),
        help: this.translate('global') + ' ' + this.translate('tracking') + ' ' + this.translate('link'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        showBorderTop: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'url_global',
            templateOptions: {
              required: true
            }
          }
        ]
      },
      {
        label: this.translate('global_postback'),
        help: this.translate('global') + ' ' + this.translate('impression') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_postback',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('global_click_postback'),
        help: this.translate('global') + ' ' + this.translate('click_after_complete') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_click_postback',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: 'Global click deep-link',
            help: 'Static deep link for campaigns with dynamic feed',
          dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
          rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_click_deeplink',
            templateOptions: {
              label: '',
              type: 'input',
              placeholder: this.translateWith('enter_here', 'URL')
            },
            extras: {validateOnModelChange: true},
            validators: {
              deepLink: {
                expression: function($viewValue, $modelValue, scope) {
                  let value = $modelValue || $viewValue;
                  let reg = /^[^ "]+:\/\/[^ "]*$/;
                  return !value || value.trim() === '' || reg.test(value);
                }
              }
            }
          }
        ]
      },
      {
        label: this.translate('android_URL') + ' ',
        help: this.translate('android') + ' ' + this.translate('tracking') + ' ' + this.translate('link'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        showBorderTop: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'url_Android',
            templateOptions: {
              label: '',
              //type: 'url',
              required: true,
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('android_postback'),
        help: this.translate('android') + ' ' + this.translate('impression') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'impression_postback_android',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('android_click_postback'),
        help: this.translate('android') + ' ' + this.translate('click') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'click_postback_android',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: 'Andr. default deep-link',
            help: 'Static deep link for campaigns with dynamic feed',
          dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'default_deep_link_android',
            templateOptions: {
              label: '',
              type: 'inout',
              placeholder: this.translateWith('enter_here', 'URL')
            },
            validators: {
              deepLink: {
                expression: function($viewValue, $modelValue, scope) {
                  let value = $modelValue || $viewValue;
                  let reg = /^[^ "]+:\/\/[^ "]*$/;
                  return !value || value.trim() === '' || reg.test(value);
                }
              }
            }
          }
        ]
      },
      {
        label: this.translate('ios_URL') + ' ',
        help: this.translate('iOS') + ' ' + this.translate('tracking') + ' ' + this.translate('link'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        showBorderTop: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'url_iOS',
            templateOptions: {
              label: '',
              //type: 'url',
              required: true,
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('ios_postback'),
        help: this.translate('ios') + ' ' + this.translate('impression') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'impression_postback_ios',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('ios_click_postback'),
        help: this.translate('ios') + ' ' + this.translate('click') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'click_postback_ios',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: 'iOS default deep-link',
            help: 'Static deep link for campaigns with dynamic feed',
          dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'default_deep_link_ios',
            templateOptions: {
              label: '',
              type: 'input',
              placeholder: this.translateWith('enter_here', 'URL')
            },
            validators: {
              deepLink: {
                expression: function($viewValue, $modelValue, scope) {
                  let value = $modelValue || $viewValue;
                  let reg = /^[^ "]+:\/\/[^ "]*$/;
                  return !value || value.trim() === '' || reg.test(value);
                }
              }
            }
          }
        ]
      },
    ];

    this.customLinksRows = [
      {
        label: this.translate('global_impression_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_impression_engagement_postback',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('global_click_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_click_engagement_postback',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('global_click_after_complete_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Global")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'global_click_after_complete_postback',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('android_impression_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'impression_engagement_postback_android',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('android_click_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'click_engagement_postback_android',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('android_click_after_complete_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("Android")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'video_complete_postback_android',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('ios_impression_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'impression_engagement_postback_ios',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('ios_click_engagement_postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'click_engagement_postback_ios',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
      {
        label: this.translate('ios_click_after_complete_postback'),
        help: this.translate('ios') + ' ' + this.translate('click_after_complete') + ' ' + this.translate('postback'),
        dynamicHide: () => {return !this.showLinksForPlatform("iOS")},
        hideBorderBottom: true,
        rowFields: [
          {
            className: 'layout__item u-5/6',
            type: 'input',
            key: 'video_complete_postback_ios',
            templateOptions: {
              label: '',
              type: 'url',
              placeholder: this.translateWith('enter_here', 'URL')
            }
          }
        ]
      },
    ];

    this.configureForm();
  }

  formatSspData(ssp) {
    return ssp.map(option => {
      return {
        id: option.id,
        value: option.name_id,
        name: option.name,
      };
    });
  }

  initSsps = () => {
    var self = this;
    this.TargetingResource.one('ssps').get()
        .then(sspChannelTargeting => {
          self.sspTypeOptions = self.formatSspData(sspChannelTargeting);
        });
  }

  getSspTypeOptions() {
    const selectedSspFees = this.campaign.ssp_fees.map(s => s.ssp_id);
    return this.sspTypeOptions.filter(s => !selectedSspFees.includes(s.id));
  }


  insertNewSSPMargin(ssp) {
    const sspOption = this.sspTypeOptions.find(s => s.name === ssp.name);
    this.campaign.ssp_fees.unshift({ ssp_id: sspOption.id, system_fee: undefined });
    this.campaign.ssp_margin_to_add = undefined;
  }

  configureForm() {
    normalizeAutoGoalsOptimizationFields(this.campaign);
    if (this.campaign.campaign_advertising_type && this.campaign.campaign_advertising_type === 'UserAcquisition') {
      this.showLookalikeField();
    }
  }

  handleStartDateChange(viewValue) {
    if (moment(viewValue).isAfter(moment(),'days') && this.campaign.status == 'active') {
      this.campaign.status = 'paused';
      this.notify.warning('campaignPausingDueToFutureStartDate');
    }
  }

  showStopReason(anchor) {
    // Default location is next to the status toggle whenever the campaign is paused — including
    // re-opening an already-paused campaign, not only an active->paused transition.
    const isPaused = this.campaign.status === 'paused';
    if (anchor === 'pause') {
      return isPaused;
    }
    if (anchor === 'endDate') {
      // Only when a specific end date is set and the campaign is not already paused; if both, the
      // top (pause) instance wins.
      return !isPaused && this.campaign.end_mode === 'specific_date' && !!this.campaign.end_date;
    }
    return false;
  }

  showLinksForPlatform(platform) {
    return this.trackingLinksToShow && this.trackingLinksToShow.includes(platform)
  }

  showCostPerEngagementField() {
    let label = 'cost_per_click';
    const help = 'cost_per_x_help';

    if (this.isEngagementCPCCampaign()) {
      label = 'cost_per_click';
    }
    else if (this.isEngagementCPACampaign()) {
      label = 'cost_per_action';
    }
    else if (this.isEngagementCPICampaign()) {
      label = 'cost_per_install';
    }
    else if (this.isEngagementCPMCampaign()) {
      label = 'cost_per_mile';
    }

    return {
      label: this.translate(label) + ' ',
      help: this.translate(help),
      helpTextPlacement: 'right',
      hide: this.isUACampaign() || this.isUACPMCampaign() || this.isBrandingCPMCampaign(),
      rowFields: [
        {
          className: 'layout__item u-3/12',
          type: 'input',
          key: 'cost_per_engagement',
          templateOptions: {
            placeholder: this.translateWith('set', label),
            required: true,
            label: ''
          },
          extras: {validateOnModelChange: true},
          validators: {
            fourDecimalDigits: {
              expression: function($viewValue, $modelValue, scope) {
                let value = $modelValue || $viewValue;
                let reg = /^[0-9]+(\.[0-9]{1,4})?$/;
                return reg.test(value);
              }
            }
          }
        },
        this.currencyField
      ]
    }
  }
  showBudgetCappingTypeField() {
    if (this.isEngagementCPCCampaign()) {
      return this.budgetCappingTypeForCPCField;
    }
    if (this.isEngagementCPACampaign()) {
      return this.budgetCappingTypeForCPAField;
    }
    if (this.isEngagementCPICampaign()) {
      return this.budgetCappingTypeForCPIField;
    }
    return this.currencyField;
  }

  hideSPCCPI() {
    return  !(this.isUACampaign() || this.isUACPMCampaign()) || !this.user.hasRole(['ADMIN','GG_ACCOUNT_MANAGER']);
  }

  isCampaignAdvertisingUA() {
    return this.campaign.campaign_advertising_type === "UserAcquisition";
  }
  isUACampaign() {
    return this.campaign.type && this.campaign.type == 'Acquisition';
  }

  removeLookalikeField() {
    _.remove(this.advancedTargetingRows, (field => field.label === this.translate('lookalike_bundles') + ' '));
  }

  showLookalikeField() {
    if (_.findIndex(this.advancedTargetingRows, {label: this.translate('lookalike_bundles') + ' '}) === -1) {
      let insertAt = 1 + _.findIndex(this.advancedTargetingRows, {label: this.translate('tree_data_type') + ' '});
      Array.prototype.splice.apply(this.advancedTargetingRows, [insertAt, 0].concat(this.lookalikeBundlesField));
    }
  }

  isUACPMCampaign() {
    return this.campaign.type && this.campaign.type == 'AcquisitionCPM';
  }

  isBrandingCPMCampaign() {
    return this.campaign.type && this.campaign.type == 'BrandingCPM';
  }

  isEngagementCPCCampaign() {
    return this.campaign.type && this.campaign.type == 'EngagementCPC';
  }

  isEngagementCPMCampaign() {
    return this.campaign.type && this.campaign.type == 'Engagement';
  }

  isEngagementCPACampaign() {
    return this.campaign.type && this.campaign.type == 'EngagementCPA';
  }

  isEngagementCPICampaign() {
    return this.campaign.type && this.campaign.type == 'EngagementCPI';
  }

  getSegments() {
    return this.$q.when(this.segments || []);
  }

  showImpressionAttributionPercentage() {
    return this.user.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER']);
  }

}

export function CampaignsFormComponent() {
  return {
    template,
    controller: CampaignsFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaign: '=',
      segments: '=',
      disabledOptions: '=',
      trackingLinksToShow: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.form', [
  ResourcesModule.name,
  ServicesModule.name,
  ConfigsModule.name
])
  .directive('campaignsForm', CampaignsFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsForm.js
 **/